"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var draft_js_1 = require("draft-js");

var scenario_utils_1 = require("../../redux/scenario/scenario.utils");

var RAW_VARIABLE_REGEXP = /\$\{([^${}\s]+)\}/g;
exports.VARIABLE_ENTITY_TYPE = 'VARIABLE';
/* Raw text to contentState
 -----------------------------------*/

/**
 * 引数で受け取った variable の key に対応する matchResults array を作成
 * see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll
 * @param variables
 * @param text
 */

exports.createVariableMatchResults = function (variables, text) {
  var matchResults = Array.from(text.matchAll(RAW_VARIABLE_REGEXP));
  return matchResults.filter(function (match) {
    return !!variables.find(function (_ref) {
      var key = _ref.key;
      return key === match[1];
    });
  });
};

exports.generateRawVariableEntityRange = function (offset, length, variableKey) {
  return {
    offset: offset,
    length: length,
    key: draft_js_1.genKey(),
    variableKey: variableKey
  };
};

exports.collectVariableRanges = function (variables, text) {
  var ranges = [];
  var parsedText = text;
  /**
   * eg) "1234 ${key1}"
   *     => match[0]: "${key1}" (rawVariableKey)
   *     => mathc[1]: "key1"  (variableKey)
   *     => index: 5
   */

  exports.createVariableMatchResults(variables, text).forEach(function (_ref2) {
    var rawVariableKey = _ref2[0],
        variableKey = _ref2[1];
    var targetVariable = variables.find(function (v) {
      return v.key === variableKey;
    });
    if (!targetVariable) throw new Error("variable with key: ".concat(variableKey, " does not exist"));
    ranges.push(exports.generateRawVariableEntityRange(parsedText.indexOf(rawVariableKey), targetVariable.value.length, variableKey));
    parsedText = parsedText.replace(rawVariableKey, targetVariable.value);
  });
  return ranges;
};

exports.convertBlockToRawVariableTextBlock = function (variables) {
  return function (block) {
    var text = block.getText();
    return {
      key: block.getKey(),
      type: block.getType(),
      text: scenario_utils_1.parseText(block.getText(), variables),
      depth: block.getDepth(),
      inlineStyleRanges: [],
      entityRanges: exports.collectVariableRanges(variables, text)
    };
  };
};
/**
 * text から RawDraftContentBlock を生成
 * - rawText を改行ごとに block の array に分解
 * - 各 block に以下の処理を実行し、rawBlock に変換
 *   - block 内部の rawVariableKey(${key}) を variable value に変換
 *   - variable value の位置情報 を取得し、entityRagens prop に渡す
 * @param variables
 * @param rawText
 */


exports.createRawVariableTextBlocks = function (variables, rawText) {
  var contentState = draft_js_1.ContentState.createFromText(rawText);
  var blocks = contentState.getBlocksAsArray();
  return blocks.map(exports.convertBlockToRawVariableTextBlock(variables));
};

exports.generateRawVariableEntity = function (variable) {
  return {
    type: exports.VARIABLE_ENTITY_TYPE,
    mutability: 'SEGMENTED',
    data: {
      variable: variable
    }
  };
};

exports.createRawVariableEntityMap = function (variables, variableRanges) {
  return variableRanges.reduce(function (map, range) {
    var variable = variables.find(function (_ref3) {
      var key = _ref3.key;
      return key === range.variableKey;
    });
    if (!variable) throw new Error("Variable with key: ".concat(range.key, " does not exist"));
    map[range.key] = exports.generateRawVariableEntity(variable);
    return map;
  }, {});
};

exports.convertRawTextToRawContentState = function (variables, rawText) {
  var rawBlocks = exports.createRawVariableTextBlocks(variables, rawText);
  var variableRanges = rawBlocks.map(function (rawBlock) {
    return rawBlock.entityRanges;
  }).flat();
  var rawVariableEntityMap = exports.createRawVariableEntityMap(variables, variableRanges);
  return {
    blocks: rawBlocks,
    entityMap: rawVariableEntityMap
  };
};
/* SELECTION
 -----------------------------------*/

/**
 * text に focus するための SelectionState を生成
 *
 * @param selection editorState の selection
 * @param blockKey focus する text を内部にもつ block の key
 * @param offset block の先頭から text までの文字数
 * @param textLength text の文字数
 */


exports.focusText = function (selection, blockKey, offset, textLength) {
  return selection.merge({
    anchorKey: blockKey,
    anchorOffset: offset,
    focusOffset: offset + textLength,
    focusKey: blockKey
  });
};
/* EditorState to raw text
 -----------------------------------*/

/**
 * entity に付与した IScenarioVariable を 取得
 * @param editorState
 * @param entityKey
 */


var extractVariableFromEditorState = function extractVariableFromEditorState(editorState, entityKey) {
  var entity = editorState.getCurrentContent().getEntity(entityKey);

  var _entity$getData = entity.getData(),
      variable = _entity$getData.variable;

  return variable;
};
/**
 * findEntityRanges() を使用し、 block 内部の entity の位置情報 (EntityRange) を取得する util
 * @param block
 */


var createEntityRanges = function createEntityRanges(block) {
  var entityRanges = [];
  var entityKey = null;
  block.findEntityRanges(function (charcters) {
    entityKey = charcters.getEntity();
    return !!entityKey;
  }, function (start, end) {
    entityRanges.push({
      entityKey: entityKey,
      start: start,
      end: end
    });
  });
  return entityRanges;
};
/**
 * block を rawText に変換
 * - entity を rawVariable に変換
 * - entity ごとに分割し、後方から entity を rawVariableKey に変換していく
 *
 * eg) "aaa VariableValue1 bbb VariableValue2 ccc"
 *    => " ccc", "VariableValue2", " bbb ", "VariableValue1", "aaa " に分解
 *    => "VariableValue1" と " ccc" 結合 -> "${VariableKey2} ccc"
 *    => "${VariableKey2} ccc" と　" bbb " 結合 -> " bbb ${VariableKey2} ccc"
 *    => " bbb ${VariableKey2} ccc" と "VariableValue1" 結合 ->  "${VariableValue1} bbb ${VariableKey2} ccc"
 *    => "${VariableValue1} bbb ${VariableKey2} ccc" と "aaa " -> "$aaa {VariableValue1} bbb ${VariableKey2} ccc"
 * @param editorState
 */


var convertBlockToRawText = function convertBlockToRawText(editorState) {
  return function (block) {
    var entityRanges = createEntityRanges(block);
    var blocKText = block.getText(); // entity が存在しない( = 変数が存在しない場合は、text をそのまま返す)

    if (entityRanges.length === 0) return blocKText;
    var convertedText = entityRanges.reverse() // 後ろの entity から処理を行うため reverse
    .reduce(function (variableText, _ref4) {
      var entityKey = _ref4.entityKey,
          start = _ref4.start,
          end = _ref4.end;
      var variable = extractVariableFromEditorState(editorState, entityKey);
      if (!variable) throw new Error("Fail to extract variable from entity with key: ".concat(entityKey));
      variableText = "${".concat(variable.key, "}").concat(blocKText.slice(end)).concat(variableText);
      blocKText = blocKText.slice(0, start);
      return variableText;
    }, '');
    return blocKText + convertedText;
  };
};

var newLine = "\n";

exports.convertEditorStateToRawText = function (editorState) {
  var blocks = editorState.getCurrentContent().getBlocksAsArray();
  return blocks.map(convertBlockToRawText(editorState)).join(newLine);
};